import React, {
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  createContext,
  useContext,
  useState
} from 'react';

interface AssessmentLayoutContextInterface {
  contentClass: string;
  setContentClass: Dispatch<SetStateAction<string>>;
  timer: boolean;
  startTimer: Dispatch<SetStateAction<boolean>>;
}

export const AssessmentLayoutContext = createContext(
  {} as AssessmentLayoutContextInterface
);

const AssessmentLayoutProvider = ({ children }: PropsWithChildren) => {
  const [timer, setTimer] = useState(false);
  const [contentClass, setContentClass] = useState('');
  return (
    <AssessmentLayoutContext.Provider
      value={{ timer, startTimer: setTimer, contentClass, setContentClass }}
    >
      {children}
    </AssessmentLayoutContext.Provider>
  );
};

export const useAssessmentLayoutContext = () =>
  useContext(AssessmentLayoutContext);

export default AssessmentLayoutProvider;
